export default "__VITE_ASSET__089e55a5__"